import { getListTourCode } from "../../data/repository/tourRepo";

export const getListTourCodeUseCase = async () => {
  const response = await getListTourCode();
  return response;
};
